import { useCallback, useSyncExternalStore } from 'react'

let activeContextMenuId: string | null = null
const listeners = new Set<() => void>()

function emit() {
    listeners.forEach((listener) => listener())
}

function setActiveContextMenuId(id: string | null) {
    activeContextMenuId = id
    emit()
}

function subscribe(listener: () => void) {
    listeners.add(listener)
    return () => listeners.delete(listener)
}

function getSnapshot() {
    return activeContextMenuId
}

export function useSinglePortalContextMenu(id: string) {
    const activeId = useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
    const opened = activeId === id

    const onChange = useCallback((nextOpened: boolean) => {
        setActiveContextMenuId(nextOpened ? id : null)
    }, [id])

    return { opened, onChange }
}
